export default "__VITE_ASSET__d0$PXwwR__"